// extracted by mini-css-extract-plugin
module.exports = {"portableText":"PortableText_portableText__sBwja"};